import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class EmployeeTrainingService {
  http: HttpClient;

  constructor(http: HttpClient) {
    this.http = http;
  }

  getRegisteredClasses() {
    return this.http.get('/Employee/GetRegisteredClasses').toPromise();
  }

  getPastRegisteredClasses() {
    return this.http.get('/Employee/GetPastRegisteredClasses').toPromise();
  }

  getAttachment(moduleID: number, data: number) {
    return this.http.get('/Document/GetDBAttachmentList?moduleID=' + moduleID + '&recordID=' + data).toPromise();
  }

  showClassDescription() {
    return this.http.get('/Employee/ShowClassDescription').toPromise();
  }

  getICSFile(classDateTime: any, classTitle: string, classLocation: string, instructorFullName: string, endDateTime: string) {
    return this.http
      .post('/Employee/DownloadICSFile', {
        classDateTime: classDateTime,
        classTitle: classTitle,
        classLocation: classLocation,
        instructorFullName: instructorFullName,
        endDateTime: endDateTime,
      })
      .toPromise();
  }

  getAvailableClasses() {
    return this.http.get('/Employee/GetAvailableClasses').toPromise();
  }

  removeClass(trainingClassId: number) {
    return this.http
      .post('/Employee/RemoveClass', {
        trainingClassId: trainingClassId,
      })
      .toPromise();
  }

  registerClass(trainingClassId: number) {
    return this.http
      .post('/Employee/RegisterForClass', {
        trainingClassId: trainingClassId,
      })
      .toPromise();
  }
}
